import cn from "classnames"

import { Popover } from "@/atoms"
import { capitalizeFirstLetter } from "@/helpers/string.helpers"
import { preventDefault } from "@/helpers/utils"
import { useTranslation } from "@/hooks/useTranslation"
import { EntityStatusIcon, InfoCircleOutlined } from "@/icons"
import { ShowMore } from "@/molecules/ShowMore"
import { IconTag } from "../IconTag"
import { ResolvedContent } from "./components/ResolvedContent"
import { TitleIssueTag } from "./components/TitleIssueTag"

import styles from "./IssueTag.module.scss"

import type { IssueTagProps } from "."

export const IssueTag = (props: IssueTagProps) => {
  const { t } = useTranslation()
  const { record, truncated, isResolvedInCodeRepo } = props

  if (isResolvedInCodeRepo)
    return (
      <Popover
        rootClassName={styles.popover}
        content={
          <div onClick={preventDefault}>
            <ShowMore.Component
              title={
                <TitleIssueTag title={t("issue.resolved.findings.code")} />
              }
            >
              <ResolvedContent component="tag" t={t} record={record} />
            </ShowMore.Component>
          </div>
        }
      >
        <div className={cn("resolved-tag-theme-ks", styles.resolvedCodeRepo)}>
          <InfoCircleOutlined />
          <span
            className={cn("sm-text-ks", styles.ellipsis)}
            data-truncated-code-repo={truncated}
          >
            {capitalizeFirstLetter(
              t("issue.resolved.findings.code").toLocaleLowerCase()
            )}
          </span>
        </div>
      </Popover>
    )

  const text = truncated ? "..." : t("general.resolved")

  return (
    <>
      <ShowMore
        id={record.id}
        label={
          <ShowMore.Label.Component>
            <IconTag
              iconSize="sm"
              icon={<EntityStatusIcon type="resolved" />}
              text={text}
              classes={{ tag: "resolved-tag-theme-ks" }}
            />
          </ShowMore.Label.Component>
        }
        classes={{
          template: styles.showMoreContainer
        }}
      >
        <ShowMore.Component
          title={<TitleIssueTag title={t("issue.resolved.title")} />}
        >
          <ResolvedContent component="tag" t={t} record={record} />
        </ShowMore.Component>
      </ShowMore>
    </>
  )
}
